// Simple error display component
// TODO: Replace with proper toast notifications (react-hot-toast) for better UX

interface ErrorMessageProps {
  error: string | null;
  className?: string;
}

export function ErrorMessage({ error, className = '' }: ErrorMessageProps) {
  if (!error) return null;

  return (
    <div className={`rounded-md bg-red-50 border border-red-200 p-3 ${className}`}>
      <div className="flex">
        <div className="text-sm text-red-800">
          <p>{error}</p>
        </div>
      </div>
    </div>
  );
}
